/**
 * 月の加算。
 * @note takezawa Date.setMonth()は1月31日+1ヶ月の場合、3月3日になってしまう（末日オーバーした際の月繰り上げ仕様がある）ので、それをせず日付を末日でリミットする月加算関数を作成した。
 * @param date 加算対象の日付
 * @param addMonth 加算月数（ヶ月）
 * @returns addMonth加算後の日付
 */
export function addMonthLimitLastDays(date: Date, addMonth: number ): Date {
  let days = date.getDate();
  let month = date.getMonth() + addMonth;
  let year = date.getFullYear();
  // 月が12月を超えた、１月下回った際の年加減算
  year = year + Math.floor(month / 12);
  month %= 12;
  if ( month < 0 ) { month = 12 + month; }

  // 末日算出
  const lastDate = new Date(year, month + 1, 0);
  const lastDays = lastDate.getDate();

  // 日の末日リミット
  if ( days > lastDays ) {
    days = lastDays;
  }

  return new Date( year, month, days);
}

/**
 * dateの月の末日を返す。
 * @param date
 */
export function calcLastDate( date: Date ): Date {
  const month = date.getMonth();
  const year = date.getFullYear();
  return new Date(year, month + 1, 0);
}

/**
 * DateオブジェクトからYYYY-MM形式の日付文字列を生成。
 */
export function formatYm(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

/**
 * DateオブジェクトからYYYY-MM-DD形式の日付文字列を生成。
 */
export function formatYmd(date: Date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * DateオブジェクトからYYYY-MM-DD hh:mm:ss形式の日付文字列を生成。
 */
export function formatYmdhms(date: Date) {
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const second = String(date.getSeconds()).padStart(2, '0');

  return formatYmd(date) + ` ${hour}:${minute}:${second}`;
}

/**
 * YYYY-MM-DD形式の日付文字列をDateオブジェクトに変換。
 */
export function parseYmd(ymd: string): Date | null {
  const [y, m, d] = ymd.split('-').map(Number);

  if (!y || !m || !d) { return null; }

  const date = new Date(y, m - 1, d);

  if (
    date.getFullYear() !== y ||
    date.getMonth() !== m - 1 ||
    date.getDate() !== d
  ) {
    return null;
  }

  return date;
}

/**
 * 日の加算。
 */
export function addDays(d: Date, n: number) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

/**
 * 日付と時間文字列からDateを生成。
 * @param date 日付
 * @param hourMinStr 時間文字列
 */
export function makeDateTimeByDateAndHourMinStr( date: Date, hourMinStr: string ): Date {
  const timeStrList = hourMinStr.split(':');

  // 24:00 指定の場合日付に加算する。
  let hour = Number(timeStrList[0]);
  const addDate = Math.floor( hour / 24 );
  hour = hour % 24;

  // 分
  const minute = Number(timeStrList[1]);

  const newDate = new Date( date.getFullYear(), date.getMonth(), date.getDate() + addDate, hour, minute );
  return newDate;
}
